import CustomCard from "../../components/Card/CustomCard";
import { FaCommentDots, FaEnvelope, FaInbox, } from "react-icons/fa";

const StakeHolderDashboard = ({ dashboardData }) => {
  return (
    <div className="row">
      <CustomCard
        title={`TOTAL QUERIES: ${dashboardData.total}`}
        count={`TODAY QUERIES: ${dashboardData.today}`}
        icon={<FaInbox />}
        isFirst={true}
        txtColor={"text-white"}
      />

      <CustomCard
        title={`UNREAD: ${dashboardData.unread}`}
        count={`READ: ${dashboardData.read}`}
        icon={<FaEnvelope />}
        iconBorderColor={"white"}
        txtColor={"txtColor"}
      />

      <CustomCard
        title={`NOT REPLIED: ${dashboardData.not_replied}`}
        count={`REPLIED: ${dashboardData.replied}`}
        icon={<FaCommentDots />}
        iconBorderColor={"white"}
        txtColor={"txtColor"}
      />
    </div>
  );
};

export default StakeHolderDashboard;
